import { Icon, type TreeMapNode, TreeMapNodeType } from '@graftcode/design-system'

import type { Gateway } from '../../../modules/gateways/types'

import { buildHostedModuleNode } from './buildHostedModuleNode'
import { mapGatewayStatusToTreeMapNodeState } from './utils/mapGatewayStatusToTreeMapNodeState'

export function buildGatewayNode(gateway: Gateway): TreeMapNode {
  const children = (gateway.hostedModules ?? []).map((module) => buildHostedModuleNode(gateway.id, module))

  return {
    id: gateway.id,
    label: gateway.name || gateway.gatewayKey || gateway.id,
    type: TreeMapNodeType.Gateway,
    icon: Icon.DSCodeGatewayFilled,
    state: mapGatewayStatusToTreeMapNodeState(gateway.status),
    metadata: {
      gatewayKey: gateway.gatewayKey,
      status: gateway.status,
    },
    children: children.length > 0 ? children : undefined,
  }
}
